import { roundNumber } from 'shared/utils/helpers/roundNumber';
import { PriceChangeDirection } from '../../model/types';

export const getAdjustedRate = (rate: Nullable<number> | undefined, percent: number, direction: PriceChangeDirection): Nullable<number> => {
  if (rate === null || rate === undefined) {
    return null;
  }

  const factor = direction === PriceChangeDirection.INCREASE ? 1 + percent / 100 : 1 - percent / 100;
  const result = roundNumber(rate * factor, 2);

  return result < 0 ? 0 : result;
};
